<template>
    <div v-if="costs && costs.length > 0" class="nopads pt-3">
        <span class="section-title">{{ $t('contract_reports.working_hour_costs') }}</span>
        <!-- Summary -->
        <div class="row">
            <div class="col-12 nopads">
                <table class="table table-sm mb-0">
                    <tbody>
                        <!-- TODO - Order division for costs -->
                        <tr class="border-horizontal">
                            <td class="table-title table-caps">{{$t('common.total')}}</td>
                            <td class="table-value table-caps">{{ totalDuration.toFixed(2) }} <span style="text-transform: none">h</span></td>
                            <td class="table-value table-caps">{{ totalCost.toFixed(2) }} {{ currency }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <!-- Work time -->
        <div v-if="tableItems.length > 0" class="row">
            <vue3-datatable
                ref="resultTable"
                :rows="tableItems"
                :columns="tableFields"
                :pagination="false"
                :sticky-header="true"
                :height="tableItems.length > 8 ? '50vh' : '100%'"
                :sortable="true"
                skin="bh-table-compact"
                row-class="routa-table-row"
                cell-class="routa-table-cell"
            >
                <template #order="row">
                    {{ row.value.order.id }} {{ getOrderAndExecutorStr(row.value.order)}}
                </template>
                <template #hourly_price="row">
                    {{ isNaN(row.value.hourly_price) ?  "-" : (row.value.hourly_price / 100).toFixed(2)  }} {{ currency }}/ h
                </template>
                <template #duration="row">
                    {{ row.value.duration.toFixed(2)  }} {{ currency }}/ h
                </template>
                <template #total="row">
                    {{ isNaN(row.value.hourly_price) ?  "0" : (row.value.duration * row.value.hourly_price / 100).toFixed(2) }} {{ currency }}
                </template>

            </vue3-datatable>
        </div>
    </div>
</template>

<script>
import {restApi} from "@/components/mixins/RestApiMixin";
import {orderMixin} from "@/components/mixins/OrderMixin";
import Vue3Datatable from "@bhplugin/vue3-datatable";

export default {
    name: "ContractReportWorkHourCosts",
    mixins: [restApi, orderMixin],
    components: {Vue3Datatable},
    props: {
        modelValue: {
            type: Number,
            default: null
        },
        searchParams: {
            type: Object,
            default() {
                return null
            }
        }
    },
    data: function () {
        return {
            costs: [],
            tableItems: [],
            tableFields: [
                {field: 'order', title: this.$t('contract_reports.order'), sort: false, headerClass: 'routa-table-header'},
                {field: 'hourly_price', title: this.$t('contract_reports.hourly_price', {currency: import.meta.env.VITE_APP_CURRENCY}), sort: false, headerClass: 'routa-table-header'},
                {field: 'duration', title: this.$t('contract_reports.duration'), sort: false, headerClass: 'routa-table-header'},
                {field: 'total', title: this.$t('common.total'), sort: false, headerClass: 'routa-table-header'},
            ],
            totalCost: 0,
            totalDuration: 0,
        }
    },
    computed: {
        currency() {
            return import.meta.env.VITE_APP_CURRENCY || '€'
        }
    },
    watch: {
        searchParams: function () {
            this.fetchCosts()
        }
    },
    mounted() {
        this.fetchCosts()
    },
    methods: {
        fetchCosts: function () {
            this.costs = []
            if (this.searchParams && this.searchParams.dateTo && this.searchParams.dateFrom && this.searchParams.contract) {
                this.$emit('loading', true)
                let params = {
                    from: this.searchParams.dateFrom,
                    to: this.searchParams.dateTo,
                    contract: this.searchParams.contract
                }
                this.restFetchParams(this.contractWorkCostUrl, params, this.handleSuccess, this.handleFail)
            }
        },
        handleSuccess: function (response) {
            this.$emit('loading', false)
            this.costs = response.data
            this.calculateSummaries()
        },
        handleFail: function () {
            this.$emit('loading', false)
        },
        calculateSummaries: function () {
            this.totalCost = 0
            this.totalDuration  = 0
            this.tableItems = []
            this.costs.forEach(cost => {
                let tableItem = this.tableItems.find(item => item.order.id === cost.order.id)
                if (tableItem) {
                    tableItem.duration += cost.duration
                } else {
                    this.tableItems.push(cost)
                }
                if (!isNaN(cost.hourly_price)) {
                    this.totalCost += cost.hourly_price * cost.duration
                }
                this.totalDuration += cost.duration
            })
            this.totalCost = this.totalCost / 100
            this.$emit('update:modelValue', this.totalCost)
        }
    }
}
</script>

<style scoped>

.table-title {
    font-size: .9em;
    text-align: left;
    font-weight: bold;
}

.table-value {
    text-align: right;
}

.table-caps {
    background: #ececec;
    font-size: 1em;
    text-transform: uppercase;
    font-weight: bold;
}

:deep(.cost-table th) {
    font-style: italic;
}

</style>
